export default __webpack_public_path__ + "static/media/close2.e20279ac.svg";